import type { TaskProgress } from '@camino-solutions/share/proto/common/services';

export class SessionTaskProcessingTaskProgressAction {
  static readonly type = '[Session] Task processing: TaskProgress';

  constructor(
    readonly cardId: string,
    readonly taskProgress: TaskProgress,
  ) {}
}
